export default __webpack_public_path__ + "static/media/default-project.4591769b.png";